import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var Flask = function Flask(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.817 13.174a1.567 1.567 0 0 1-1.565-1.565c0-.864.702-1.566 1.565-1.566a1.567 1.567 0 0 1 0 3.13m.783 4.697a.783.783 0 1 1 .002-1.567.783.783 0 0 1-.002 1.567m-3.522-1.566a1.175 1.175 0 0 1-1.174-1.174c0-.647.527-1.173 1.174-1.173.647 0 1.174.526 1.174 1.173 0 .648-.527 1.174-1.174 1.174m7.226-3.786c1.065 1.158 2.166 2.357 2.166 5.743 0 1.792-.947 2.739-2.74 2.739H7.34c-1.793 0-2.74-.947-2.74-2.74 0-3.385 1.1-4.584 2.165-5.742 1.1-1.197 2.14-2.328 2.14-5.996 0-.217.175-.392.39-.392h5.479c.216 0 .391.175.391.392 0 3.668 1.04 4.799 2.14 5.996zm-8.791-7.17a.391.391 0 0 1-.391-.391V3.39c0-.216.175-.391.391-.391h7.044c.216 0 .39.175.39.391v1.566a.391.391 0 0 1-.39.39H8.513z"
  })));
};

Flask.displayName = 'Flask';
export default Flask;